import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { ApplicationService } from 'services/application.service';

@Component({
  selector: 'app-vumatelapplicationhistory',
  templateUrl: './vumatelapplicationhistory.component.html',
  styleUrls: ['./vumatelapplicationhistory.component.scss']
})
export class VumatelapplicationhistoryComponent implements OnInit {

  data: any;
  isTrue:false;
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = [
    'Status',
    'Date',
    'Done By'
  ];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  routeParams: any;
  applicationid: number;
  isAppHistory: boolean;
  data1: any;
  isShowNodata: boolean;
  
  constructor(
    private applicationService: ApplicationService,
    private route: ActivatedRoute,  

  ) { 
    this.routeParams = route.snapshot.params;
    this.applicationid = +this.routeParams.id;
  }

  ngOnInit() {

    this.getUserDetails(true);
    // this.getAppHistoryDetails(true);

  }

  getUserDetails(refresh) {
    debugger
        this.isAppHistory = false;
    try {
      this.applicationService.getWebHookByApplicationId(this.applicationid).subscribe(result => {
        // if(result.length > 0 ){
        //   this.isShowNodata = false;
        this.data = result;
        this.dataSource = new MatTableDataSource(this.data);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        // }
        // else{
        //   this.isShowNodata  = true;
        // }
      });

    } catch (error) {

    }
  }

  getAppHistoryDetails(event){
    debugger
    if(event.checked){
  this.isAppHistory = true;
    this.applicationService.getAppHistoryDetId(this.applicationid).subscribe(result => {
      // if(result.length > 0){
      //   this.isShowNodata= false;
      this.data1 = result;
      console.log(result)
      console.log("success")
      this.dataSource = new MatTableDataSource(this.data1);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      // }
      //   else{
      //     this.isShowNodata = true;
      //   }
    })
  }else{
    this.isAppHistory = false
    this.getUserDetails(true);
  };

  }

}
